import type { ApolloError } from '@apollo/client'

import type { EditRefereeErrors } from '@/components/EntityPanels/Referee/utils'

export interface ErrorContext<T> {
  description: string
  reason: T
}

export const getErrorsFromGraphQLExtensions = (error: ApolloError) =>
  error.graphQLErrors.reduce((acc, graphQLError) => {
    if (
      graphQLError.extensions?.code === 'BAD_GATEWAY' &&
      graphQLError.extensions?.errors !== undefined
    ) {
      return [...acc, ...(graphQLError.extensions.errors as ErrorContext<string>[])]
    }

    return acc
  }, [] as ErrorContext<string>[])

export const getErrorReasonsFromGraphQLExtensions = (error: ApolloError) =>
  error.graphQLErrors
    .reduce((acc, graphQLError) => {
      const extensions = graphQLError.extensions as {
        [attributeName: string]: ErrorContext<EditRefereeErrors>
      }

      const resons = graphQLError.extensions
        ? Object.keys(graphQLError.extensions).map(key => extensions[key]?.reason)
        : []
      return [...acc, ...resons]
    }, [] as EditRefereeErrors[])
    .filter(reason => reason !== undefined)
